import { render, staticRenderFns } from "./RecetaDetallada.vue?vue&type=template&id=54b4ccd4&scoped=true&"
import script from "./RecetaDetallada.vue?vue&type=script&lang=js&"
export * from "./RecetaDetallada.vue?vue&type=script&lang=js&"
import style0 from "./RecetaDetallada.vue?vue&type=style&index=0&id=54b4ccd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4ccd4",
  null
  
)

export default component.exports